import { differenceInCalendarDays, format } from 'date-fns';
import { de, enUS, ru } from 'date-fns/locale';
import { defineMessage, IntlShape } from 'react-intl';

const TODAY = defineMessage({ id: 'today', defaultMessage: 'Сегодня' });

export const getDayAndMonth = (date: number | Date, intl: IntlShape): string => {
	const difference = differenceInCalendarDays(new Date(), date);
	let locale;
	switch (intl.locale) {
		case 'de':
			locale = de;
			break;
		case 'en':
			locale = enUS;
			break;
		case 'ru':
			locale = ru;
			break;
		default:
			console.warn('unsupported locale ' + intl.locale);
	}
	if (difference > 0) {
		return format(date, 'dd MMMM', { locale });
	}
	return intl.formatMessage(TODAY);
};
